module.exports = __webpack_public_path__ + "img/fr.11614fc4.svg";